export const ALERT_LEVEL = {
  CRITICAL: "critical",
  CRITICAL_CODE: 2,
  WARNING: "warning",
  WARNING_CODE: 1,
  NORMAL: "normal",
  NORMAL_CODE: 0,
  CRITICAL_WARNING: "criticalWithWarning",
};

export const DROPDOWN_WIDTH = 97;
export const LOADING_TEXT = "Loading...";
export const SYSTEM_NOT_AVAILABLE = "System not available";
export const DEVICE_HEALTH_GOOD = "Health Status - Good";
